import React, { useState, useEffect, useCallback, useLayoutEffect, useMemo } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { isBefore } from "date-fns";
import Parse from 'html-react-parser';
// redux
import store from "store";
import { RootState } from "store/ducks";
import { useDispatch, useSelector } from "react-redux";
// context
import DistributionCenterContext from "../store/distribution-center-context";
// assets
import ErrorIcon from "img/error-img.svg";
import SuccessIcon from "img/success-img.svg";
// components
import ModalCD from "./Modal/index";
import Modal from "components/Modal";
import { Toggle } from "../components/Toggle";
import toast from "components/Toast/dispatch";
import { LastHits } from "../components/LastHits";
import { Visibility } from "components/Visibility";
import QuotesMapping from "../Mapping/QuotesMapping";
import { Row, Column } from "components/Layout/Grid";
import { ScrollToTop } from "../components/ScrollToTop";
import ModalNotParticipate from './ModalNotParticipate';
import { ActionTag } from "../components/Tags/ActionTag";
import ErrorModal from '../components/generics/Modal/Error';
import { Subtitles } from "../components/generics/Subtitles";
import ModalLoader from "../components/generics/Modal/Loader";
import { BackButton } from "../components/generics/BackButton";
import SuccessModal from '../components/generics/Modal/Success';
import { QuoteCategoryTab } from "../components/QuoteCategoryTab";
import { DetailsHeaderButtons } from "../components/DetailsHeaderButtons";
import PaymentTermModal from "../Mapping/PaymentTermModal/PaymentTermModal";
import QuoteHeaderInformations from "../components/QuoteHeaderInformations";
import FinancialPendingMatterModal from "../components/generics/Modal/FinancialPendingMatterModal";
import PriceHistoryModal from "pages/Quotes/components/generics/Modal/PriceHistoryModal/PriceHistoryModal";
import ObservationFieldModal from "pages/Quotes/components/generics/Modal/ObservationFieldModal/ObservationFieldModal";
// services
import BCGServices from "services/bcg.service";
import QuoteServices from "services/quote.service";
import QuoteBionexoServices from "services/quoteBionexo.service";
import DomainSettingService from "services/domainSetting.service";
import KeycloakPubServiceInstance from "services/keycloakpubsub.service";
// models
import { ITabProps } from "models/QuoteDetail";
import { ProductSelectedProps } from "./interface";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
//interfaces
import { QuotationOrigin, QuotationOriginType, StatusType, SupplierStatusType } from "components/Table/interface";
import { IFinancialCreditInformations } from "../components/generics/Modal/FinancialPendingMatterModal/interface";
//context
import { useTabsContext } from "contexts/Tabs";
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
// utils
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import { toastify as message } from "components/Toastify/utils";
import { handleUserRedirect } from "../Dashboard/utils";
import { checkIsBudgetSavedOthersUsers, getBlockedBranches } from "./utils";
import { subtitlesQuoteDetails } from "../components/generics/Subtitles/utils";
import { UpdateApprovedMapAutomaticProps } from "models/MapProduct";
import MapProductService from 'services/quoteMapProduct.service';
import { IItemDeclined } from "models/portalModels/ItemDeclined";

// styles
import "./style.scss";
import "../styles.scss";

const QuotesDetails: React.FC = () => {
  // Navigation
  const navigate = useNavigate();
  const { id } = useParams<any>();
  const location: any = useLocation();
  const { state, pathname } = location;
  // const environment
  const blockedSimultaneousAccess = process.env.REACT_APP_BLOCKED_SIMULTANEOUS_ACCESS;
  const checkToggleEnable = JSON.parse(process.env.REACT_APP_CHECK_TOGGLE_ENABLE!);
  //redux
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const quotesDetailsStore = useSelector((state: RootState) => state.quotesDetails);
  const savedBudgets = useSelector((state: RootState) => state.savedBudgets) ?? [];
  const toastify = useSelector((state: RootState) => state.toastify);

  const [openModal, setOpenModal] = useState({ isOpen: false });
  const [quoteId, setQuoteId] = useState<string | undefined>("");
  const [supplierNote, setSupplierNote] = useState<any>("");
  const [supplierStatus, setSupplierStatus] = useState<any>("");
  const [NotParticipateStatus, setNotParticipateStatus] = useState<any>("");
  const [notParticipateStatusLabel, setNotParticipateStatusLabel] = useState<any>("");
  const [isActiveNotParticipate, setIsActiveNotParticipate] = useState<boolean>(true);
  const [distributionCenter, setDistributionCenters] = useState<any>({ distributionCenters: [] });
  const [selectCD, setSelectCD] = useState<any>("");
  const [selectCDModal, setSelectCDModal] = useState<any>("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [productSelected, setProductSelected] = useState<ProductSelectedProps[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [isNoSegmented, setIsNoSegmented] = useState(!checkToggleEnable ? false : true);
  const [refreshControl, setRefreshControl] = useState(false);
  const [otherOption, setOtherOption] = useState<boolean>(false);
  const [enableButtonApproveSuggestions, setEnableButtonApproveSuggestions] = useState<boolean>(false);
  //modals
  const [modalLoader, setModalLoader] = useState(false);
  const [isDeparaModalDisplayed, setIsDeparaModalDisplayed] = useState(false);
  const [openItemObsModal, setOpenItemObsModal] = useState(false);
  const [modalNotParticipate, setModalNotParticipate] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [financialPendingMatterModal, setFinancialPendingMatterModal] = useState(false);

  const [obsIcon, setObsIcon] = useState<boolean>(false);
  const [segmentSelected, setSegmentSelected] = useState("");
  const [oldSegmentSelected, setOldSegmentSelected] = useState("");
  const [removeAllFromToSegment, setRemoveAllFromToSegment] = useState(true);
  const [financialCreditInformations, setFinancialCreditInformations] = useState<Array<IFinancialCreditInformations>>([]);
  //services
  const _bcgService = new BCGServices();
  const _quoteServices = new QuoteServices();
  const _quoteBionexoServices = new QuoteBionexoServices();
  const _domainSettingService = new DomainSettingService();

  const { setDisableTabs, disableTabs } = useTabsContext();
  const {
    quoteItem,
    quoteDetail,
    currentPage,
    setUseMoney,
    setQuoteItem,
    setQuoteDetail,
    setCurrentPage,
    sequenceNumber,
    renderAgainMoney,
    setFirstLoadPage,
    itemPriceHistory,
    setSequenceNumber,
    setRenderAgainMoney,
    resetItemPriceHistory,
    modalPaymentTermModal,
    showPriceHistoryModal,
    secondDetailPageRender,
    setModalPaymentTermModal,
    setSecondDetailPageRender
  } = useDetailsQuoteContext();

  const isQuoteExpired = quoteDetail ? isBefore(new Date(quoteDetail.expiresAt!), new Date()) : true;

  const toolTipText = isQuoteExpired ? 'Cotações expiradas não podem ser enviadas.' : 'Selecione o servidor para gravar a cotação.';

  const enableToggle = quoteDetail! &&
    ((quoteDetail?.status !== StatusType.CLOSED && quoteDetail?.supplierStatus !== SupplierStatusType.EXPIRED) ||
      (quoteDetail?.status !== StatusType.CLOSED && quoteDetail?.supplierStatus !== SupplierStatusType.DO_NOT_PARTICIPATE));

  const refreshTableQuotesDashboard = () => {
    dispatch({ type: "RELOAD_TABLE_QUOTES", data: { reload: true } });
  };

  const setQuoteAnalyzed = async (id: string) => await _quoteServices.CheckAnalyzedQuote(id);

  useEffect(() => {
    if (state && !state.viewList && quoteDetail?.quoteWithAutomaticItems)
      setQuoteAnalyzed(state.id);
  }, [state]);

  const checkUserAccessQuote = async (idQuoteAccessLink: string) => {
    const response = await _quoteServices.checkQuotationViewed(idQuoteAccessLink);

    const users: string[] = response.data.data.user;

    if (users && !users.includes(user?.fullName ?? '') && (blockedSimultaneousAccess)) {
      navigate('/cotacoes-dashboard', { state: { redirectQuote: true } });

      const description = Parse(`<p class='text-styles color-blue-gray mt-3 text-wrap text-center description-quote-blocked'>Essa cotação esta sendo manipulada pelo colaborador <b>${users[0]}</b>. Aguarde a finalização para acessar as informações.</p>`);
      toast.errorCustom('Importante!', description, ErrorIcon, true, 'Fechar', 19, 14, true, refreshTableQuotesDashboard);
    }
  };

  useEffect(() => {
    const idQuoteLink = pathname.split('/')[2];

    if (user) {
      dataBCG();
      checkUserAccessQuote(idQuoteLink);
    }
  }, [state, user, blockedSimultaneousAccess]);

  // TODO - centralizar esse método (Details, SavedInMoney, Dashboard)
  const dataUserBCG = useMemo(async () => {
    if (IsNullOrEmpty(user?.representative)) {
      try {
        const response = await _bcgService.getUserByUserName(user?.username ?? "");
        if (response.status === 200) {
          dispatch({ type: 'SET_REPRESENTATIVE_USER', representative: response.data.representativeCode, buBCG: response.data.identifier, isBCGUser: true });
          return { representative: response.data.representativeCode, bu: response.data.identifier };
        }
      } catch {
        // ignore
      }
      dispatch({ type: 'SET_REPRESENTATIVE_USER', representative: "", isBCGUser: false, buBCG: "" });
      return { representative: "", bu: "" };
    } else
      return { representative: user?.representative, bu: user?.buBCG };
  }, []);

  const dataBCG = async () => await dataUserBCG;

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
  }

  const forceUpdate = useForceUpdate();

  const showDeParaModal = (quoteId: string, sequenceNumber: string) => {
    setSequenceNumber(sequenceNumber);
    setIsDeparaModalDisplayed(true);
    document.body.style.overflow = "hidden";
  };
  const hideDeParaModal = () => {
    setSequenceNumber("");
    setIsDeparaModalDisplayed(false);
    setEnableButtonApproveSuggestions(false);
    forceUpdate();
    document.body.style.overflow = "visible";
  };

  const resetGrid = useCallback(async (cdValue = "") => {
    if (!quoteId || (!quotesDetailsStore?.distributionCenter && !cdValue))
      return;

    KeycloakPubServiceInstance.subscribe(async () => {
      setModalLoader(true);
      await _quoteServices.resetAllBugets({
        quoteId,
        distributionCenter: cdValue
          ? cdValue
          : quotesDetailsStore?.distributionCenter,
      });

      setQuoteItem(undefined);

      setCurrentPage(0);
      setProductSelected([]);

      if (cdValue) setStorageCD(cdValue);
      setHasMore(true);
    });
  }, [quoteId, quotesDetailsStore?.distributionCenter]);

  const setStorageCD = (value: any) => {
    store.dispatch({ type: "SET_DISTRIBUTION_CENTER", value });
  };

  const allBudgetsSavedsInQuote = async () => {
    const response = await _quoteServices.allBudgetsSavedInQuote(quoteId ?? "");

    if (response.data) {
      setProductSelected(response.data.data);
    }
  };

  useEffect(() => {
    if (quoteId) {
      dispatch({ type: 'BUDGET_SENT', data: { sent: false } });
      allBudgetsSavedsInQuote();
    }
  }, [quoteId]);

  useLayoutEffect(() => {
    if (!quoteDetail) {
      if (quoteId !== "") {
        getDetail(quoteId ?? "");
      } else {
        setQuoteId(id);
      }
    } else {
      if (!quoteDetail?.renderNewTabs) {
        getDistributionCenter(quoteId);
        setSelectCD(quoteDetail?.distributionCenterDefault);
      }
    }
  }, [quoteId, quoteDetail]);

  useEffect(() => {
    user && handleUserRedirect(user, history);
  }, [user]);

  useEffect(() => {
    if (supplierNote || quoteDetail?.notes) {
      setObsIcon(true);
    } else {
      setObsIcon(false);
    }

  }, [supplierNote, quoteDetail]);

  useEffect(() => {
    if (!quotesDetailsStore?.distributionCenter) return;
    setSelectCD(quotesDetailsStore?.distributionCenter);

    return () => {
      setStorageCD("");
    };
  }, [quotesDetailsStore?.distributionCenter]);

  useEffect(() => {
    if (productSelected?.length > 0 && !isQuoteExpired) {
      selectCD && setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [productSelected, selectCD]);

  useEffect(() => {
    const idQuoteLink = pathname.split('/')[2];

    if (state?.id || idQuoteLink) {
      return () => {
        _quoteServices.updateFinishDate(state?.id || idQuoteLink);

        dispatch({
          type: 'SET_QUOTE_ITEM',
          data: { id: state?.id || idQuoteLink, blockedQuote: blockedSimultaneousAccess }
        });
      };
    }
  }, [state, blockedSimultaneousAccess]);

  const newTabsOrderWithSegments = (newTabs: ITabProps[], oldTabs?: ITabProps[]) => {
    const indexOldSegmentSelected = newTabs.find(x => x.segmentTab === segmentSelected);

    if (oldTabs?.length !== newTabs.length && newTabs[0].segmentTab !== segmentSelected || ((oldTabs?.length === newTabs.length) && (oldTabs[0].segmentTab !== newTabs[0].segmentTab)) || !indexOldSegmentSelected) {
      setHasMore(true);
      setCurrentPage(0);
      setQuoteItem(undefined);
      setRemoveAllFromToSegment(true);
      setSegmentSelected(newTabs[0].segmentTab);
    }
  };

  useEffect(() => {
    setHasMore(true);
    setCurrentPage(0);
    setQuoteItem(undefined);
    setRemoveAllFromToSegment(true);

    if (!isNoSegmented) {
      setSegmentSelected(quoteDetail?.tabs[0].segmentTab!);
    } else {
      setSegmentSelected("");
    }
  }, [isNoSegmented]);

  const _mapProductService = new MapProductService();

  const getDetail = useCallback(async (quoteIdDetail: string) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      setQuoteItem(undefined);

      const result = await _quoteServices.quoteDetails(quoteIdDetail);

      if (result?.data && !result?.error) {
        setQuoteDetail(result.data);
        
        if (!isNoSegmented) {
          setRemoveAllFromToSegment(false);
          const tabsOld = quoteDetail?.tabs;

          const tabsNew = result.data.tabs;

          newTabsOrderWithSegments(tabsNew, tabsOld);

          setSegmentSelected(result.data.tabs[0].segmentTab);
        }

        dispatch({
          type: "SET_CUSTOMER_CODE",
          customerCode: result.data.customerCode,
        });
        getUnblockedDCs(result.data.customerCode);
      }
    });
  }, []);

  const reloadTable = (quoteIdReload: string) => {
    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.quoteDetails(quoteIdReload);

      if (result?.data && !result?.error) {
        setQuoteDetail(result.data);

        if (!isNoSegmented) {
          setRemoveAllFromToSegment(false);
          const tabsOld = quoteDetail?.tabs;

          const tabsNew = result.data.tabs;
          newTabsOrderWithSegments(tabsNew, tabsOld);
        }
      }
    });
  };

  const getDistributionCenter = useCallback(async (quoteId: any) => {
    setSupplierNote(quoteDetail?.supplierNote);
    setNotParticipateStatus(quoteDetail?.notParticipateStatus);
    setNotParticipateStatusLabel(quoteDetail?.notParticipateStatus);
    setSupplierStatus(quoteDetail?.supplierStatus);
    if (quoteDetail?.supplierStatus === "Não participar" && quoteDetail?.status === StatusType.CANCELED)
      setIsActiveNotParticipate(false);

    if (!quoteId || !quoteDetail) return;

    if (quoteDetail?.distributionCenterDefault) {
      setStorageCD(quoteDetail.distributionCenterDefault);
    } else {
      setOpenModal({ isOpen: true });
    }
  }, [quoteId, quoteDetail]);

  useEffect(() => {
    if (renderAgainMoney) {
      setSecondDetailPageRender(false);
      getQuoteSuggestionDetailSegment(true);
    }
  }, [renderAgainMoney]);

  const getQuoteSuggestionDetailSegment = async (useMoney: boolean) => {
    const qtdItemsSegment = quoteDetail?.tabs.find(x => x.segmentTab === segmentSelected)?.count ?? 0;
    setDisableTabs(true);
    setUseMoney(false);

    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.quoteSuggestionDetailSegment(
        quoteId ?? "",
        segmentSelected,
        qtdItemsSegment,
        isNoSegmented,
        useMoney,
        currentPage + 1,
      );

      if (result?.data && Array.isArray(result?.data)) {
        const { error, data, totalPages, pageSize, total } = result;

        let loadedPage = currentPage + 1;
        const oldQuoteItem: any = quoteItem?.data || [];

        setQuoteItem({
          error,
          data: currentPage === 0 ? [...data] : [...oldQuoteItem, ...data],
          totalPages,
          pageSize: pageSize,
          total,
        });

        setModalLoader(false);

        if (useMoney) {
          setUseMoney(true);
          setHasMore(loadedPage !== totalPages);
          setSecondDetailPageRender(true);
          setDisableTabs(false);
          setFirstLoadPage(false);
        }
      } else {
        if (useMoney) {
          setUseMoney(true);
          setRenderAgainMoney(false);
          setSecondDetailPageRender(true);
          setDisableTabs(false);
          setFirstLoadPage(false);
        } else {
          setQuoteItem({
            error: true,
            pageSize: 0,
            total: 0,
            totalPages: 0,
            data: undefined
          });
        }

        setHasMore(false);
        setModalLoader(false);
        setRefreshControl(false);
      }
    });
  };

  useEffect(() => {
    if (refreshControl) {
      setQuoteItem(undefined);
    }

    if (!hasMore && !refreshControl || !quoteId ||
      segmentSelected === '' && !isNoSegmented ||
      (!quoteItem?.data?.length && currentPage !== 0) ||
      !selectCD ||
      (!removeAllFromToSegment && (segmentSelected === oldSegmentSelected)) ||
      !secondDetailPageRender && currentPage !== 0
    )
      return;

    setSecondDetailPageRender(false);
    Promise.all([getQuoteSuggestionDetailSegment(false), getQuoteSuggestionDetailSegment(true)]);
  }, [currentPage, quoteId, hasMore, selectCD, segmentSelected, refreshControl]);

  const updateQuoteStatus = (itemSequenceNumber: number, status: boolean) => {
    if (!quoteItem?.data) return;

    let newQuoteItems: any = quoteItem.data;

    let updatedQuoteItemIndex = quoteItem.data.findIndex(
      (item) => Number(item.sequenceNumber) === itemSequenceNumber
    );

    const item = quoteItem.data.find((item) => item?.productsSuggestion);
    const itemStock = item?.productsSuggestion![0]?.itemStock;

    if (updatedQuoteItemIndex === undefined) return;

    updatedQuoteItemIndex += 1;

    const itemStockIndex = itemStock!.findIndex(
      (item: any) => item.local === quotesDetailsStore?.distributionCenter
    );

    if (
      itemStockIndex === undefined ||
      !newQuoteItems[0] ||
      !newQuoteItems[0]?.productsSuggestion[0]?.itemStock[itemStockIndex]
    )
      return;

    newQuoteItems[0].productsSuggestion[0].itemStock[
      itemStockIndex
    ].blocked = status;

    setQuoteItem({ ...quoteItem, data: newQuoteItems });
  };

  const refreshItem = useCallback(
    (
      field: string,
      value?: any,
      sequenceNumber?: string,
      filterDetail?: string,
      valueFilterDetail?: any
    ) => {
      if (!quoteItem?.data) return;

      const fields = field.split(".");

      let index: number = quoteItem?.data.findIndex(
        (item) => item.sequenceNumber == sequenceNumber
      );
      let data = Object.assign(quoteItem?.data) as Array<IQuoteDetailItem>;

      let item = {};

      type field0 = keyof typeof data[0];

      if (fields.length == 1) {
        let detailItemObj: IQuoteDetailItem = { [fields[0] as field0]: value };
        item = { ...data[index], ...detailItemObj };
      } else if (fields.length == 2) {
        const itemDetail = data[index][fields[0] as field0];
        if (!itemDetail.length) return;

        const indexDetail = itemDetail.findIndex(
          (item: any) => item[filterDetail!] == valueFilterDetail
        );

        if (indexDetail < 0) return;

        let detailItemObj = { [fields[1]]: value };
        itemDetail[indexDetail] = {
          ...itemDetail[indexDetail],
          ...detailItemObj,
        };

        item = { ...data[index], [fields[0]]: itemDetail };
      }

      data[index] = item;

      setQuoteItem({ ...quoteItem, data: data });
    }, [quoteItem]);

  const getUnblockedDCs = useCallback(async (customerCode?: any) => {
    const clientId = customerCode;
    KeycloakPubServiceInstance.subscribe(async () => {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      let origin = Number(quoteDetail?.origin) || QuotationOrigin.BIONEXO;
      
      const pageText = document.body.textContent || document.body.innerText || '';
      if (pageText.includes('MVM')) {
        origin = QuotationOrigin.MVM;
      }
      
      const result = await _domainSettingService.getUnblockedDistributionCenters(clientId, origin);
      const blockedBranches = await getBlockedBranches();

      if (result?.data) {
        const { data } = result;
        const options = data?.map((result: any) => {
          return {
            id: clientId,
            value: result.branchName,
            disabled: result.blocked,
            label: result.description,
          };
        });
        setDistributionCenters({
          distributionCenters: options.filter((item: any) => !item.disabled && !blockedBranches.includes(item.value)),
        });
      } else {
        toast.error(
          "Não foi possível carregar Centro de Distribuições. Tente carregar a página novamente, por favor."
        );
      }
    });
  }, [quoteDetail?.origin]);

  const changeCDAndResetQuote = (cdValue: string) => {
    if (!cdValue) return;
    toast.yesNo(
      "Atenção! Ao trocar o CD de gravação, todas \n os orçamentos salvos serão descartados.\n\n Deseja prosseguir com a alteração do CD?",
      async () => {
        await resetGrid(cdValue);
        setProductSelected([]);
        dispatch({ type: "CLOSE_TOAST" });
        dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: [] });
      },
      "Trocar CD",
      "Cancelar"
    );
  };

  const getFinancialCreditInformations = async () => {
    KeycloakPubServiceInstance.subscribe(async () => {
      const result = await _quoteServices.getFinancialCreditInformations(quoteDetail?.customerCode!);
      if (result.status === 200) {
        setFinancialCreditInformations(result.data.data);
      }
    });
  };

  const handleRedirectToOrders = () => {
    navigate('/pedidos', { 
      state: { 
        filterQuoteCode: quoteDetail?.quoteCode,
        fromQuoteDetails: true
      } 
    });
  };

  const setReset = async () => {
    setOpenModal({ isOpen: false });
    await resetGrid(selectCDModal);
  };

  const handleCloseDcModal = () => {
    setOpenModal({ isOpen: false });
    navigate("/cotacoes-dashboard");
  };

  const handleOpenFinancialPendingMatterModal = async () => {
    await getFinancialCreditInformations();
    setFinancialPendingMatterModal(true);
  };

  const handleCloseFinancialPendingMatterModal = () => {
    setFinancialPendingMatterModal(false);
  };

  const reproveMapProduct = async (item: IQuoteDetailItem) => {
    const modalData: IItemDeclined = {
      automaticItemDeclinedType: "",
      automaticItemDeclinedMessage: "",
    };

    const errorMessage = "Não foi possível remover a sugestão";

    if (!quoteId || !item.sequenceNumber) {
      message.error(errorMessage);  
      return;
    };

    const quoteData = quoteItem?.data;

    const itemData = quoteData ? quoteData.find((data) => data.sequenceNumber === item.sequenceNumber) : undefined

    if (!itemData || !itemData.productsSuggestion) {
      message.error(errorMessage);  
      return;
    }

    const suggestedIndex = itemData.productsSuggestion.findIndex((data) => data.id === item.id);

    if (suggestedIndex > -1) {
      itemData.productsSuggestion.splice(suggestedIndex, 1);
    }

    const response = await _mapProductService.updateDeclinedItemReason(quoteId, item.sequenceNumber!, item.id!, Number(item.sequenceNumber), modalData);

    if (response.status === 200) {
      const newProductSuggestion = itemData.productsSuggestion[0];

      if (newProductSuggestion) {
        newProductSuggestion.suggested = true;
        setEnableButtonApproveSuggestions(true);
      }

      message.success("Sugestão removida com sucesso.");
      refreshItem('productsSuggestion', itemData?.productsSuggestion, item.sequenceNumber);
      showDeParaModal(quoteId, item.sequenceNumber);
    } else {
      message.error(errorMessage);
    }
  };

  const approveMapProduct = async (id: string, sequenceNumber: number, data: UpdateApprovedMapAutomaticProps) => {
    setModalLoader(true);
    
    const quoteData = quoteItem?.data;
    const itemData = quoteData ? quoteData.find((item) => Number(item.sequenceNumber) === sequenceNumber) : undefined

    const suggested = itemData ? itemData.productsSuggestion?.find((data) => data.id === id) : undefined

    if (suggested) {
      suggested.isApproved = true;
      suggested.isCreatedAutomatically = false;
    }

    const response = await _mapProductService.UpdateApprovedMapAutomatic(data);

    if (response.status === 200) {
      message.success("De/Para aprovado");
      refreshItem('productsSuggestion', itemData?.productsSuggestion, sequenceNumber.toString());
    } else
      message.error("Não foi possível atualizar o De/Para");

    setModalLoader(false);
  };

  useEffect(() => {
    const main = document.querySelector('main > div');

    main?.classList.add('overflow-x-hidden');
    return () => {
      setCurrentPage(0);
      setFirstLoadPage(true);
      setQuoteItem(undefined);
      setQuoteDetail(undefined);
      main?.classList.remove('overflow-x-hidden');
      dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: [] });
    };
  }, []);

  useEffect(() => {
    if (
      quoteDetail?.status === StatusType.CLOSED ||
      quoteDetail?.supplierStatus === SupplierStatusType.EXPIRED ||
      quoteDetail?.supplierStatus === SupplierStatusType.DO_NOT_PARTICIPATE
    ) {
      setDisableBtn(true);
    }
  }, [quoteDetail]);

  useEffect(() => {
    if (toastify.show) {
      message.success("De/Para salvo com sucesso");
    }

    dispatch({ type: "SHOW_TOASTIFY", data: { show: false } });
  }, [toastify.show]);

  useEffect(() => {
    if (quoteItem?.data && secondDetailPageRender) {
      const items = quoteItem.data.filter(item => item.isValid && item.productsSuggestion?.length === 0);

      if (items.length > 0) {
        const sequenceNumbers = items.flatMap(item => Number(item.sequenceNumber));

        resetMultipleBudgets(sequenceNumbers);
      }
    }
  }, [quoteItem]);

  const resetMultipleBudgets = async (sequenceNumbers: number[]) => {
    const response = await _quoteServices.resetMultipleBugets(quoteId ?? "", sequenceNumbers);
    if (response.status === 200) {
      getAllBudgetsSaved();
      allBudgetsSavedsInQuote();
    }
  };

  const getAllBudgetsSaved = async () => {
    const response = await _quoteServices.budgetsSavedInQuote(quoteId ?? "", false);

    if (response.status === 200) {
      dispatch({ type: 'SET_ALL_BUDGETS_SAVED', data: response.data.data });
    }
  };

  return (
    <DistributionCenterContext.Provider
      value={{
        distributionCenters: distributionCenter?.distributionCenters,
        quoteId: quoteId,
      }}
    >
      {modalLoader && <ModalLoader />}

      <BackButton />

      <Row className="detail-header-row">
        <div className="flex-row d-flex flex-center">
          <Column className="flex-5 quote-title">
            <p className="main-title-quote">{quoteDetail?.customerName} | {quoteDetail?.customerUF}</p>
            <Row>
              <Column className="flex-center flex-5 mt-1">
                <p className="quote-subtitle">
                  Cód. Interno {quoteDetail?.quoteCode} | Cód. Cliente{" "}
                  {quoteDetail?.customerCode}{" "}
                  <Visibility visible={!!quoteDetail?.categoryMafra}>
                    | Cat. Cotação Mafra: {quoteDetail?.categoryMafra}
                  </Visibility>
                </p>
              </Column>
            </Row>
          </Column>          
        </div>

        <Visibility visible={!!quoteDetail}>
          <DetailsHeaderButtons
            user={user}
            quoteId={quoteId}
            selectCD={selectCD}
            disableBtn={disableBtn}
            toolTipText={toolTipText}
            savedBudgets={savedBudgets}
            blockedDispatch={dispatch}
            productSelected={productSelected}
            obsIconCondition={obsIcon}
            distributionCenter={distributionCenter}
            setOpenItemObsModal={setOpenItemObsModal}
            changeCDAndResetQuote={changeCDAndResetQuote}
            setModalNotParticipate={setModalNotParticipate}
            isActiveNotParticipate={isActiveNotParticipate}
            notParticipateStatusLabel={notParticipateStatusLabel}
            checkIsBudgetSavedOthersUsers={checkIsBudgetSavedOthersUsers}
          />
        </Visibility>
      </Row>

      <Column className="mt-2">
        <Visibility visible={!!(quoteDetail && quoteDetail?.financialPending?.length > 0)}>
          <ActionTag 
            tagTitle="Títulos em atraso" 
            onClick={handleOpenFinancialPendingMatterModal}
            hasMarginLeft />
        </Visibility>
      </Column>

      <QuoteHeaderInformations supplierStatus={supplierStatus} />

      <Visibility visible={!IsNullOrEmpty(quoteId)}>
        <LastHits quoteId={quoteId ?? ""} />
      </Visibility>

      <ScrollToTop />

      <Row className="flex-1 flex-row">
        <Visibility visible={checkToggleEnable && enableToggle}>
          <Row className="flex-1 mb-2 align-center justify-start">
            <Toggle
              isLine={false}
              label={`Abas ${isNoSegmented ? "Desabilitadas" : "Habilitadas"}`}
              id="toogleSegment"
              toggled={!isNoSegmented}
              onChange={() => !disableTabs && setIsNoSegmented(!isNoSegmented)}
            />
          </Row>
        </Visibility>
      </Row>

      <QuoteCategoryTab
        state={state}
        quoteId={quoteId ?? ""}
        hasMore={hasMore}
        setHasMore={setHasMore}
        refreshItem={refreshItem}
        isNoSegmented={isNoSegmented}
        segmentSelected={segmentSelected}
        showDeParaModal={showDeParaModal}
        productSelected={productSelected}
        updateQuoteStatus={updateQuoteStatus}
        setRefreshControl={setRefreshControl}
        setSegmentSelected={setSegmentSelected}
        setProductSelected={setProductSelected}
        setOldSegmentSelected={setOldSegmentSelected}
        customerCode={quotesDetailsStore?.customerCode}
        setRemoveAllFromToSegment={setRemoveAllFromToSegment}
        distributionCenters={distributionCenter.distributionCenters}
        reproveMapProduct={reproveMapProduct}
        approveMapProduct={approveMapProduct}
      />

      {modalPaymentTermModal && (
        <PaymentTermModal
          quoteId={quoteId ?? ""}
          onCloseAction={() => setModalPaymentTermModal(false)}
          productSelected={productSelected}
        />
      )}

      {/* MODAL PARA ESCOLHER DC */}
      {openModal?.isOpen && !modalLoader && (
        <Modal
          children={
            <ModalCD
              distributionCenters={distributionCenter.distributionCenters}
              selectCD={selectCDModal}
              setSelectCD={setSelectCDModal}
              setOpenModal={setOpenModal}
              handleCloseDcModal={handleCloseDcModal}
              onClick={setReset}
            />
          }
          onCloseAction={() => { }}
          title=""
          width="10"
          height="100"
        />
      )}

      <Visibility visible={isDeparaModalDisplayed}>
        <div className="z-index-modal-quotes-mapping">
          <Modal className="bg-background" borderRadius="8px" title="" width="95%" minWidth="" height="95%">
            <QuotesMapping
              quoteId={quoteId ?? ""}
              selectCD={selectCD}
              reloadTable={reloadTable}
              isNoSegmented={isNoSegmented}
              sequenceNumber={sequenceNumber}
              onCloseAction={hideDeParaModal}
              segmentSelected={segmentSelected}
              distributionCenter={distributionCenter}
              enableButtonApproveSuggestions={enableButtonApproveSuggestions}
            />
          </Modal>
        </div>
      </Visibility>

      {openItemObsModal && (
        <Modal title="" width={"1100px"} height={"352px"}>
          <ObservationFieldModal
            item={{ ...quoteDetail, supplierNote, quoteId }}
            handleCloseItemObsModal={() => setOpenItemObsModal(false)}
            setSupplierNote={setSupplierNote}
          />
        </Modal>
      )}

      {modalNotParticipate && (
        <Modal title=""
          width={'344px'}
          minWidth={'344px'}
          height={otherOption ? '342px' : '254px'}
          borderRadius={'8px'}
        >
          <ModalNotParticipate
            handleCloseModal={() => setModalNotParticipate(false)}
            quoteDetail={{ ...quoteDetail, NotParticipateStatus, quoteId }}
            setNotParticipateStatus={setNotParticipateStatus}
            setIsActiveNotParticipate={setIsActiveNotParticipate}
            setSupplierStatus={setSupplierStatus}
            setSuccessModal={() => setSuccessModal(true)}
            setNotParticipateStatusLabel={setNotParticipateStatusLabel}
            setOtherOption={setOtherOption}
          />
        </Modal>
      )}

      {successModal && (
        <Modal
          title=''
          width={'440px'}
          minWidth={'440px'}
          height={'313px'}
        >
          <SuccessModal
            text={'Cotação finalizada com sucesso!'}
            icon={SuccessIcon}
            buttonText={'Ok'}
            setSuccessModal={() => setSuccessModal(false)}
          />
        </Modal>
      )}

      {errorModal && (
        <Modal
          title=''
          width={'470px'}
          minWidth={'470px'}
          height={'423px'}
        >
          <ErrorModal
            icon={ErrorIcon}
            title={'Importante!'}
            deleteButtonText={'Cancelar'}
            continueButtonText={'Continuar'}
            setErrorModal={() => setErrorModal(false)}
          />
        </Modal>
      )}

      <Visibility visible={financialPendingMatterModal}>
        <Modal
          title=''
          width={'418px'}
          minWidth={'418px'}
          borderRadius={'8px'}
        >
          <FinancialPendingMatterModal
            financialCreditInformations={financialCreditInformations}
            handleCloseFinancialPendingMatterModal={handleCloseFinancialPendingMatterModal}
          />
        </Modal>
      </Visibility>

      <Visibility visible={showPriceHistoryModal && !IsNullOrEmpty(sequenceNumber) && !IsNullOrEmpty(itemPriceHistory)}>
        <PriceHistoryModal
          item={itemPriceHistory}
          quoteDetail={quoteDetail}
          onCloseAction={() => resetItemPriceHistory()}
        />
      </Visibility>
      <Subtitles subtitles={subtitlesQuoteDetails} />
    </DistributionCenterContext.Provider>
  );
};

export default QuotesDetails;
